import React from "react";
import { useIntl } from "react-intl";
import { object } from "yup";
import { Button, Badge, Form, Space, Row } from "@masterteam/mt-design-react";

import AdminFormModal from "../../AdminFormModal";
import { ReactComponent as ReplaceUserIcon } from "../../../assets/images/replace-user.svg";
import { ReactComponent as ReplaceWithIcon } from "../../../assets/images/replace-with.svg";

import api from "../../../providers/api";
import { addToast } from "../../../helpers";

const { Field } = Form;

const initialValues = {
  User: null,
  NewUser: null,
};

const validationSchema = object().shape({
  User: object().required(" ").nullable(),
  NewUser: object().required(" ").nullable(),
});

function ReplaceUser({ usersList, showModal, closeHandler }) {
  const intl = useIntl();

  function replaceUser(values, { setIsSubmitting }) {
    const { User, NewUser } = values;
    const body = {
      User: User.UserName,
      NewUser: NewUser.UserName,
    };
    api.user
      .replace(body)
      .then((res) => {
        const { StatusCode, StatusMessage } = res;
        if (StatusCode === "Success") {
          addToast.success("user-management.user-replaced-successfuly");
          closeHandler(values, true);
        } else {
          addToast.error(StatusMessage, {
            toastId: "get-users-error",
          });
        }
      })
      .catch((error) => {
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <AdminFormModal
      title={intl.formatMessage({ id: "user.replace-user" })}
      Icon={ReplaceUserIcon}
      isOpen={showModal}
      onClose={closeHandler}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={replaceUser}
      >
        {({ values, isSubmitting, isValid }) => (
          <>
            <Space
              direction="vertical"
              className="user-replace-form-container add-user-form"
            >
              <Row>
                <small>
                  {intl.formatMessage({ id: "user.replace-warning" })}
                </small>
              </Row>
              <Space direction="vertical" size="medium" className="form-body">
                <Row align="center" size="large" className="form-container">
                  <Field
                    type="select"
                    name="User"
                    inputProps={{
                      placeholder: intl.formatMessage({ id: "common.user" }),
                      options: usersList.filter(
                        (item) => item.UserName !== values.NewUser?.UserName
                      ),
                      getOptionLabel: (item) => item.DisplayName,
                      getOptionValue: (item) => item.UserName,
                      maxMenuHeight: "100px",
                    }}
                    hideLabel
                    hideErrorMessage
                  />
                  <Badge
                    className="btn_default replace-with-btn"
                    Icon={ReplaceWithIcon}
                  >
                    {intl.formatMessage({ id: "user.with" })}
                  </Badge>
                  <Field
                    type="select"
                    name="NewUser"
                    inputProps={{
                      placeholder: intl.formatMessage({ id: "user.new-user" }),
                      options: usersList.filter(
                        (item) => item.UserName !== values.User?.UserName
                      ),
                      getOptionLabel: (item) => item.DisplayName,
                      getOptionValue: (item) => item.UserName,
                      maxMenuHeight: "100px",
                    }}
                    hideLabel
                    hideErrorMessage
                  />
                </Row>
                <Row size="small" justify="end">
                  <Button variant="dark" onClick={closeHandler}>
                    {intl.formatMessage({ id: "common.cancel" })}
                  </Button>
                  <Button
                    loading={isSubmitting}
                    type="submit"
                    disabled={!isValid}
                    fixed
                  >
                    {intl.formatMessage({ id: "common.replace" })}
                  </Button>
                </Row>
              </Space>
            </Space>
          </>
        )}
      </Form>
    </AdminFormModal>
  );
}

export default ReplaceUser;
